import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { StrategyMapDownloadService } from './strategy-map-download.service';

@Component({
  selector: 'app-strategy-map-download',
  templateUrl: './strategy-map-download.component.html',
  styleUrls: ['./strategy-map-download.component.scss']
})
export class StrategyMapDownloadComponent implements OnInit {
  @Output() close = new EventEmitter<void>();

  constructor(private strategyMapDownloadService: StrategyMapDownloadService) {}

  ngOnInit() { }

  get isFormVisible(): boolean {
    return this.strategyMapDownloadService.isFormVisible;
  }

  get isRecipientsVisible(): boolean {
    return this.strategyMapDownloadService.isRecipientsVisible;
  }

  get isConfirmVisible(): boolean {
    return this.strategyMapDownloadService.isConfirmVisible;
  }

  closeModal(): void {
    this.close.emit();
  }

}

